import type { LC } from '@use-gpu/live';

import { yeet } from '@use-gpu/live';
import { dispatch, DispatchProps } from '../queue/dispatch';
import { usePassContext } from '../providers/pass-provider';

export type RenderDispatchProps = Pick<DispatchProps, 'size' | 'group' | 'indirect' | 'shader' | 'shouldDispatch' | 'onDispatch' | 'defines' | 'label'>;

export const RenderDispatch: LC<RenderDispatchProps> = (props: RenderDispatchProps) => {
  const {bindGroups: {color: {layout: globalLayout, key: pipelineKey}}} = usePassContext();

  return yeet(dispatch({
    ...props,
    globalLayout,
    pipelineKey,
  }));
};
